import React, { useState, useEffect } from 'react';
import { Modal, Form, Button } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { toggleForgotSerialNumberModal } from 'software_renewal/redux/slice';
import { sendSerialNumberRecoveryEmail } from 'software_renewal/redux/thunks';
import { selectShowForgotSerialNumberModal, selectRecoveryEmailError, selectLoading } from 'software_renewal/redux/selectors';
import { toast } from 'react-hot-toast';

const ForgotSerialNumberModal = () => {
  const dispatch = useDispatch();
  const showForgotSerialNumberModal = useSelector(selectShowForgotSerialNumberModal);
  const error = useSelector(selectRecoveryEmailError);
  const loading = useSelector(selectLoading);
  const [email, setEmail] = useState('');

  const onHide = () => {
    dispatch(toggleForgotSerialNumberModal(false));
  };

  const onSubmit = async () => {
    try {
      await dispatch(sendSerialNumberRecoveryEmail(email)).unwrap();
      toast.success('Email sent successfully');
    } finally {
      onHide();
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      onSubmit();
    }
  };

  useEffect(() => {
    if (error) {
      toast.error(error);
    }
  }, [error]);

  return (
    <Modal
      show={showForgotSerialNumberModal}
      onHide={onHide}
      onShow={() => setEmail('')}
    >
      <Modal.Header closeButton>
        <Modal.Title>Forgot Serial Number</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>
          If you have forgotten your serial number, please enter your email below and we will send you a link to reset your serial number.
        </p>
        <Form>
          <Form.Group controlId="email">
            <Form.Label>Email</Form.Label>
            <Form.Control
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              onKeyPress={handleKeyPress}
              type="email"
              placeholder="Enter email"
            />
          </Form.Group>
        </Form>

        <Button variant="primary" onClick={onSubmit} disabled={loading}>
          {loading ? 'Sending...' : 'Send Email'}
        </Button>
      </Modal.Body>
    </Modal>
  );
};

export default ForgotSerialNumberModal;
